export const WLS_RPC_URL = process.env.WLS_RPC_URL || 'https://pubrpc.wlsworld.vip';

export default null;
